import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatBytes } from 'utils/helpers/formatters';
import TooltipWrapper from 'components/TooltipWrapper';
import { FaTrash } from 'react-icons/fa';
import styled from 'styled-components';
import Button from 'components/Button';

interface IAttachment {
  id: number;
  file_name: string;
  size: number;
}

interface IProps {
  items: IAttachment[];
  onDelete: (id: number) => void;
}

const LONG_FILE_NAME_THRESHOLD = 30;

const Attachments: FC<IProps> = ({ items, onDelete }: IProps) => {
  const { t } = useTranslation();
  return (
    <>
      <h4 className="text-center mb-4">{t('common.currentlyUploadedFiles')}</h4>
      <ul>
        {items.map((file: IAttachment) => {
          const isLongFileName = file.file_name.length > LONG_FILE_NAME_THRESHOLD;
          const fileNameSpan = <FileNameSpan className="font-weight-bold">{file.file_name}</FileNameSpan>;

          return (
            <li key={file.id}>
              <FlexWrapper className="mb-2">
                <NameWrapper>
                  {isLongFileName ? (
                    <TooltipWrapper
                      id={`tooltip-attachment-name-${file.id}`}
                      overlay={file.file_name}
                      style={{ flex: 1, minWidth: 0 }}
                    >
                      {fileNameSpan}
                    </TooltipWrapper>
                  ) : (
                    fileNameSpan
                  )}
                  <span className="flex-shrink-0">&nbsp;-&nbsp;{formatBytes(file.size)}</span>
                </NameWrapper>
                <div className="d-inline-block flex-shrink-0">
                  <TooltipWrapper
                    id="tooltip-trash"
                    overlay="Изтрий"
                  >
                    <Button
                      btnType="danger"
                      size="sm"
                      outlined
                      onClick={() => onDelete(file.id)}
                      className="ml-2"
                    >
                      <FaTrash size={14} />
                    </Button>
                  </TooltipWrapper>
                </div>
              </FlexWrapper>
            </li>
          );
        })}
      </ul>
    </>
  );
};

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const NameWrapper = styled.div`
  display: flex;
  align-items: baseline;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
`;

const FileNameSpan = styled.span`
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;

export default Attachments;
